"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLoadingSafetyEventDetails = exports.setSafetyEventDetails = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var safetyEventDetails_model_1 = require("../models/safetyEventDetails.model");
var safetyEventDetailsSlice = (0, toolkit_1.createSlice)({
    name: 'vehicles',
    initialState: (0, safetyEventDetails_model_1.safetyEventDetailsStateFactory)(),
    reducers: {
        setSafetyEventDetails: function (state, action) {
            state.safetyEventDetails = action.payload;
        },
        setLoadingSafetyEventDetails: function (state, action) {
            state.loadingSafetyEventDetails = action.payload;
        },
    },
});
var actions = safetyEventDetailsSlice.actions, reducer = safetyEventDetailsSlice.reducer;
exports.setSafetyEventDetails = actions.setSafetyEventDetails, exports.setLoadingSafetyEventDetails = actions.setLoadingSafetyEventDetails;
exports.default = reducer;
